var _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalInfosolutionsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 300,
    viewBox: "0 0 400 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1E5AA8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 35,
    width: 75,
    height: 8,
    rx: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177,
    cy: 39,
    r: 6,
    fill: "none",
    stroke: "#1E5AA8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268,
    cy: 39,
    r: 6,
    fill: "none",
    stroke: "#1E5AA8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 50,
    width: 8,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 50,
    width: 8,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 50,
    width: 8,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 50,
    width: 8,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 50,
    width: 8,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255,
    y: 50,
    width: 8,
    height: 110
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 160,
    width: 105,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 175,
    width: 60,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 185,
    width: 105,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 150,
    width: 25,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 140,
    width: 25,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 130,
    width: 25,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 140,
    width: 8,
    height: 20
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 230,
    textAnchor: "middle",
    fill: "#1E5AA8",
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    letterSpacing: "2px"
  }, "\r\n    LEGAL INFOSOLUTIONS PVT LTD.\r\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalInfosolutionsLogo);
export default __webpack_public_path__ + "static/media/legal-infosolutions-logo.0ab826fdbae3371059ac7378a43c3d1e.svg";
export { ForwardRef as ReactComponent };